import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Antd from 'ant-design-vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate  from 'pinia-plugin-persistedstate';
import 'ant-design-vue/dist/reset.css';
import './assets/styles/global.css';
const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(Antd);
app.use(router);
app.use(pinia);
app.mount('#app');